import React from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'

import { useBaseTheme } from 'Hooks'

import { _ } from 'Services/I18n'

import { StyledButton } from '../styles'

function BookNowButton({ service, onClick }) {
  const { primaryColor, primaryTextColor, roundedBorder } = useBaseTheme()

  const showBookNow = get(service, 'is_book_button_visible', true)
  const bookButtonLabel =
    get(service, 'book_button_label') || _('common.bookNow')

  if (!showBookNow) {
    return null
  }

  return (
    <StyledButton
      background={primaryColor}
      color={primaryTextColor}
      roundedborder={roundedBorder}
      onClick={onClick}
    >
      {bookButtonLabel.toUpperCase()}
    </StyledButton>
  )
}

BookNowButton.defaultProps = {
  onClick: () => {},
}

BookNowButton.propTypes = {
  service: PropTypes.object.isRequired,
  onClick: PropTypes.func,
}

export default BookNowButton
